import WbIncandescentOutlinedIcon from "@mui/icons-material/WbIncandescentOutlined";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import "./Index.css";

const InformationShower = ({
  sentence,
  icon_type,
  is_cursor = false,
  span_class = "",
  para_color = "",
  bg_color = "",
  handleClick = () => {},
}) => {
  const renderIcon = () => {
    switch (icon_type) {
      case "HINT":
        return <WbIncandescentOutlinedIcon />;
      case "PRIORITY":
        return <PriorityHighIcon />;
    }
  };
  return (
    <>
      <div
        style={{
          cursor: is_cursor ? "pointer" : "",
          backgroundColor: bg_color,
        }}
        onClick={handleClick}
        className="d-flex-juscon-sb-align-center gap-15 hint-container"
      >
        <span className={span_class}>{renderIcon()}</span>
        <p style={{ color: para_color }}>{sentence}</p>
      </div>
    </>
  );
};
export default InformationShower;
